export default [
  {
    path: '/:lang/inquiry/offer/:id',
    name: 'InquiryOffer',
    component: () => import('~/pages/inquiry/offer/offer.vue'),
    meta: {
      name: 'InquiryOffer',
      pageCode: 'ERA.UC.INQUIRYODDER',
      noPc: true,
      // needToken: true,
    },
  },
  {
    path: '/:lang/inquiry/freightinquiry/postFreightInquiry/:id',
    name: 'InquiryOffer',
    component: () => import('~/pages/inquiry/offer/offer.vue'),
    meta: {
      name: 'InquiryOffer',
      pageCode: 'ERA.UC.Inquiry.POSTFREIGHTINQUIRY',
      // needToken: true,
    },
  },
  {
    path: '/:lang/inquiry/offerSuccess',
    name: 'OfferSuccess',
    component: () => import('~/pages/inquiry/offer/offerSuccess.vue'),
    meta: {
      name: 'OfferSuccess',
      pageCode: 'ERA.UC.OFFERSUCCESS',
      noPc: true,
    },
  },
  {
    path: '/:lang/inquiry/checkEmail',
    name: 'CheckEmail',
    component: () => import('@/pages/inquiry/checkEmail/index.vue'),
    meta: {
      name: 'CheckEmail',
      pageCode: 'ERA.UC.CHECKEMAIL',
      noPc: true,
      // needToken: true,
    },
  },
]
